// ============================================================================
// APP MODE — which search engine the app opens into.
//
// The campaign voter search (/main) is TEMPORARILY STOPPED, so the app lands on
// the SIR 2026 enumeration search (/sir) instead.
//
// 👉 TO TURN THE CAMPAIGN APP BACK ON: set CAMPAIGN_SEARCH_ENABLED = true.
//    That single change restores everything — login lands on /main again, /main
//    stops redirecting, and the "Voter Search" button reappears in the SIR page.
//    Nothing else has to be touched.
// ============================================================================

/** false = /main is off and redirects to /sir. true = normal campaign app. */
export const CAMPAIGN_SEARCH_ENABLED = false;

/** Where a successful login / OTP verification should land. */
export const HOME_ROUTE = CAMPAIGN_SEARCH_ENABLED ? "/main" : "/sir";

/**
 * Where the login screen lives.
 *
 * While the campaign app is off, "/" belongs to the PUBLIC SIR search — that is
 * the free-then-paid product, and a stranger arriving at the site must land on
 * a search box, not a login form for an account they do not have. Staff sign in
 * at /login instead, and every "go back to the login screen" in the app points
 * here rather than at "/".
 *
 * With CAMPAIGN_SEARCH_ENABLED = true this becomes "/" again and the old
 * behaviour returns untouched.
 */
export const LOGIN_ROUTE = CAMPAIGN_SEARCH_ENABLED ? "/" : "/login";
